import { type FeatureModule } from '@store/features/types';
import storage from 'redux-persist/lib/storage';

import dismissalsReducer from './slice';

export const systemNotificationsFeature: FeatureModule = {
  id: 'systemNotifications',
  name: 'System Notifications',
  dependencies: [],
  reducers: {
    'systemNotifications/dismissals': dismissalsReducer,
  },
  middleware: [],
  persistence: {
    enabled: true,
    storage: storage, // localStorage via redux-persist
    whitelist: ['persistentDismissedIds'], // Only this gets persisted
    // sessionDismissedIds is NOT in whitelist = memory only, resets on refresh
  },
  setup: _store => {
    // No manual setup needed - redux-persist handles rehydration
  },
};
